




































import { createComponent, ref, computed } from "@vue/composition-api";
import { useRouting } from "@dcc/compositions/useRouting";
import {
  BaseCounter,
  BaseLink,
  BasePrimaryButton
} from "@web-components";
import { getActions } from "@dcc/store/drinking/actions";
import { findGetters } from "@dcc/store/drinking/getters";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

export default createComponent({
  components: {
    BaseCounter,
    BaseLink,
    BasePrimaryButton
  },
  setup(props: {}, context) {
    const { handleNext, handlePrev } = useRouting(context);
    const dictionary = useDictionary();

    const { getNumberMonthlyDrinkingDays } = findGetters(context.root.$store);
    const drinkingDays = ref(getNumberMonthlyDrinkingDays().value);
    const { updateMonthlyDrinkingDays } = getActions(context.root.$store);

    const handleNextClicked = () => {
      updateMonthlyDrinkingDays(drinkingDays.value);
      handleNext();
    };

    const nextIsDisabled = computed(
      () => drinkingDays.value <= 0 || drinkingDays.value > 4
    );
    return {
      drinkingDays,
      handleNextClicked,
      nextIsDisabled,
      handlePrev,
      ...dictionary
    };
  }
});
